module.exports = function browserRequired(module_name) {
    if (typeof window === 'undefined') {
        throw new Error(`This module is not meant to run outside the browser. Caller: ${module_name}`)
    }
}
